module.exports = __webpack_public_path__ + "img/toLottery.22b3a3f0.png";